$(function() {
        $(".ques-heading")
            .click(function(j) {
                var dropDown = $(this)
                    .closest(".questions__item_row")
                    .find(".ques-desc");
                $(this)
                    .closest(".question-body")
                    .find(".ques-desc")
                    .not(dropDown)
                    .slideUp(), $(this)
                    .hasClass("active") ? $(this)
                    .removeClass("active") : ($(".ques-heading.active")
                        .removeClass("active"), $(this)
                        .addClass("active")), dropDown.stop(!1, !0)
                    .slideToggle(), j.preventDefault()
            })
    }), $(function() {
        $('body.product-duo input[name="Bundle & Save"][value="2 Pack"]')
            .prop("checked", !0), $('body.product-duo input[name="Bundle & Save"][value="2 Set"]')
            .prop("checked", !0), $('body.product-duo input[name="Bundle & Save"][value="2 Jar"]')
            .prop("checked", !0), $('body.product-duo input[name="Buy 1 Get 1 FREE"][value="2 Pack"]')
            .prop("checked", !0), $('body.product-duo input[name="Buy 1 Free 1"][value="2 Pack"]')
            .prop("checked", !0), setTimeout(function() {
                $(".custom-no-js")
                    .removeClass("custom-no-js")
            }, 3500);
        var check_var_price = $(".qty_swatch input:checked+label")
            .find(".var_price")
            .text()
            , check_comvar_price = $(".qty_swatch input:checked+label")
            .find(".var_com_price")
            .text();
        $(".desk_stcy_price, .stcy_pro_price")
            .text(check_var_price), $(".stcy_compro_price")
            .text(check_comvar_price), console.log("readuy"), $(".qty_swatch .element")
            .click(function() {
                console.log("clickk");
                var var_price = $(this)
                    .find(".var_price")
                    .text()
                    , comvar_price = $(this)
                    .find(".var_price")
                    .text();
                $(".desk_stcy_price, .stcy_pro_price")
                    .text(var_price), $(".stcy_compro_price")
                    .text(comvar_price)
            })
    }), $(document)
    .ready(function() {
        $(".tab_nav li:first-child")
            .addClass("active"), $(".tabcontent")
            .hide(), $(".tabcontent:first")
            .show(), $(".tab_nav li")
            .click(function() {
                $(".tab_nav li")
                    .removeClass("active"), $(this)
                    .addClass("active"), $(".tabcontent")
                    .hide();
                var activeTab = $(this)
                    .find("a")
                    .attr("href");
                return $(activeTab)
                    .fadeIn(), !1
            }),
          
          $("a.value-props-btn")
            .click(function(e) {
                e.preventDefault(), $(".value-props-modal")
                    .css("display", "block"), $("body")
                    .css("overflow-y", "hidden")
            }), $(".close-modal,.modal-sandbox")
            .click(function(e) {
                e.preventDefault(), $(".value-props-modal")
                    .css("display", "none"), $("body")
                    .css("overflow-y", "auto")
            }), $(".our_iwt_slider")
            .slick({
                infinite: !0
                , slidesToShow: 1
                , slidesToScroll: 1
                , arrows: !1
                , dots: !0
                , centerMode: !0
                , centerPadding: "25%"
                , responsive: [{
                    breakpoint: 576
                    , settings: {
                        centerPadding: "10%"
                    }
                }]
            }), $(".review_main_slider")
            .slick({
                infinite: !0
                , slidesToShow: 3
                , slidesToScroll: 1
                , arrows: !0
                , autoplay: !0
                , autoplaySpeed: 2e3
                , dots: !1
                , responsive: [{
                    breakpoint: 768
                    , settings: {
                        slidesToShow: 2
                        , slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480
                    , settings: {
                        slidesToShow: 1
                        , slidesToScroll: 1
                    }
                }]
            }), $(".beforeafter-carousel")
            .slick({
                infinite: !0
                , slidesToShow: 1
                , slidesToScroll: 1
                , arrows: !0
                , dots: !1
                , autoplay: !1
                , autoplaySpeed: 2e3
            }), $(".pro-richtext-reviews")
            .slick({
                infinite: !0
                , slidesToShow: 1
                , slidesToScroll: 1
                , arrows: !1
                , dots: !0
                , autoplay: !0
                , autoplaySpeed: 2e3
            }), $(".brand-carousel")
            .slick({
                infinite: !0
                , slidesToShow: 4
                , slidesToScroll: 1
                , arrows: !1
                , dots: !1
                , responsive: [{
                    breakpoint: 768
                    , settings: {
                        slidesToShow: 2
                        , slidesToScroll: 1
                    }
                }, {
                    breakpoint: 600
                    , settings: {
                        slidesToShow: 2
                        , slidesToScroll: 2
                    }
                }]
            }), $("a.smooth-redirect")
            .on("click", function(e) {
                e.preventDefault();
                var target = this.hash
                    , $target = $(target);
                $("html, body")
                    .stop()
                    .animate({
                        scrollTop: $target.offset()
                            .top
                    }, 300, "swing", function() {})
            })
    }), $(window)
    .width() <= 767 && $(window)
    .scroll(function() {
        var scrolledY = $(window)
            .scrollTop();
        $(".index_rich_text .gradient")
            .css("background-position", "center " + scrolledY + "0px")
    }), $(document)
    .ready(function() {
        $(".faq_btn")
            .on("click", function() {
                $(this)
                    .toggleClass("open")
                    .next()
                    .slideToggle(300)
            })
    }), $(document)
    .ready(function() {
        function logoSlider() {
            $(".as-feat-section .main-logo-section")
                .slick({
                    infinite: !0
                    , slidesToShow: 3
                    , slidesToScroll: 1
                    , arrows: !0
                    , autoplay: !0
                    , autoplaySpeed: 2e3
                    , dots: !1
                    , responsive: [{
                        breakpoint: 767
                        , settings: {
                            slidesToShow: 1
                            , slidesToScroll: 1
                        }
                    }]
                })
        }
        $(window)
            .resize(function() {
                $(window)
                    .width() <= 991 && logoSlider()
            }), $(window)
            .width() <= 991 && logoSlider()
    }), $(document)
    .ready(function() {
        $(".global-media-settings video")
            .length > 0 && setTimeout(function() {
                document.querySelector(".global-media-settings video")
                    .play()
            }, 1e3), $(".video-container")
            .each(function() {
                var $video_container = $(this)
                    , $video = $(this)
                    .find("video")
                    , $video_controls = $(this)
                    .find(".video-inner-container")
                    , $play_button = $(this)
                    .find(".play-gif");

                function playVideo() {
                    $video[0].paused ? ($video[0].play(), $video_controls.addClass("playing")) : ($video[0].pause(), $video_controls.removeClass("playing"))
                }
                $play_button.click(function() {
                    playVideo()
                })
            });
        var vids = $(".video-container video");
        $.each(vids, function() {
                this.controls = !1
            }), $(document)
            .on("click", ".pro-stamped-badge", function() {
                $("html,body")
                    .animate({
                        scrollTop: $("#stamped-main-widget")
                            .offset()
                            .top
                    }, 1e3)
            }), $(".slider-video")
            .slick({
                infinite: !0
                , slidesToShow: 2
                , slidesToScroll: 1
                , arrows: !1
                , dots: !1
                , responsive: [{
                    breakpoint: 991
                    , settings: {
                        slidesToShow: 1
                        , slidesToScroll: 1
                    }
                }, {
                    breakpoint: 768
                    , settings: {
                        slidesToShow: 1
                        , slidesToScroll: 1
                    }
                }]
            })
    }), $(document)
    .ready(function() {
        $(".desk_sticky_cart")
            .hide(), $(".sticky_cart.mbl_cart")
            .hide(), $("button.play-pause.bar.paused")
            .length > 0 && $("button.play-pause.bar.paused")
            .trigger("click"), $(".sticky_addtocart, .product-iwt-claim .claim-btn, .pro-vid-img-section .vid_img_btn .btn")
            .click(function() {
                $(".product-form__submit")
                    .trigger("click")
            })
    }), window.addEventListener("load", function() {
        var _learnq = window._learnq || [];

        function addedToCart() {
            fetch(`${window.location.origin}/cart.js`)
                .then(res => res.clone()
                    .json()
                    .then(data => {
                        var cart = {
                            total_price: data.total_price / 100
                            , $value: data.total_price / 100
                            , total_discount: data.total_discount
                            , original_total_price: data.original_total_price / 100
                            , items: data.items
                        };
                        item !== "undefined" && (cart = Object.assign(cart, item)), klAjax && (_learnq.push(["track", "Added to Cart", cart]), klAjax = !1)
                    }))
        }(function(ns, fetch2) {
            ns.fetch = function() {
                const response = fetch2.apply(this, arguments);
                return response.then(res => {
                    `${window.location.origin}/cart/add.js`.includes(res.url) && addedToCart()
                }), response
            }
        })(window, window.fetch);
        for (var klAjax = !0, atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']"), i = 0; i < atcButtons.length; i++) atcButtons[i].addEventListener("click", function() {
            klAjax && (_learnq.push(["track", "Added to Cart", item]), klAjax = !1)
        })
    }), $(window)
    .scroll(function() {
        if ($("#shopify-section-footer")
            .length > 0 && $("#shopify-section-newsletter")
            .length > 0) {
            $("body")
                .addClass("gradient-fixed"), $(".sticky_cart.mbl_cart")
                .hide();
            var footer_offset = $("#shopify-section-footer")
                .offset()
                .top - 250
                , sticky_height = $(window)
                .height()
                , scroll = $(window)
                .scrollTop()
                , sticky_new_top = $("#shopify-section-newsletter")
                .offset()
                .top;
            sticky_new_top -= sticky_height, scroll >= sticky_new_top ? $(".desk_sticky_cart")
                .addClass("hide") : $(".desk_sticky_cart")
                .removeClass("hide"), scroll >= footer_offset ? $(".desk_sticky_cart")
                .hide() : $(".desk_sticky_cart")
                .show()
        }
        if ($(window)
            .width() <= 767) {
            $(".desk_sticky_cart")
                .hide();
            var sticky_top;
            sticky_top -= sticky_height, scroll >= sticky_top && ($(".sticky_cart.mbl_cart")
                .show(), scroll >= footer_offset ? $(".sticky_cart.mbl_cart")
                .hide() : $(".sticky_cart.mbl_cart")
                .show())
        }
    });
